module.exports = __webpack_public_path__ + "static/img/betslip-slip-guide-txt.047b3d8.png";